module.exports = __webpack_public_path__ + "img/logo-light-icon.7e9b2a0b.png";